import type { FormResponse } from "@/models/new/formResponse.types"
import type { Form } from "@/models/new/forms.types"
import type { ReportCreationMedia } from "@/components/vivid-report-editor/report-creation-media"
import { getDynamicGroupInstances } from "@/components/vivid-report-editor/dynamic-group-reindex"

/** Dynamic evidence needs a response slot, not necessarily a nonempty answer. */
export const publicFieldMediaValidationMessage = (
  form: Form,
  response: FormResponse,
  media: ReportCreationMedia,
  resolvedInstances: Record<string, number[]>,
): string | undefined => {
  const affected = Object.entries(media.fieldMedia).flatMap(([locator, bundle]) => {
    const { groupId, instance, fieldName } = bundle.target
    if (
      !groupId ||
      instance === undefined ||
      Object.prototype.hasOwnProperty.call(response.responses, locator)
    )
      return []
    const group = form.fields
      .flatMap((section) => section.fields)
      .find((field) => field.id === groupId)
    if (group?.type !== "dynamicGroup") return [] // Server validates unknown targets.
    const child = group.fields.find((field) => field.name === fieldName)
    if (!child) return []
    const instances = [
      ...new Set([
        ...getDynamicGroupInstances(response.responses, groupId, undefined, [
          ...Object.keys(media.responseUploads),
          ...Object.keys(media.fieldMedia),
        ]),
        ...(resolvedInstances[groupId] ?? []),
      ]),
    ].sort((a, b) => a - b)
    return [`${group.label} #${instances.indexOf(instance) + 1} — ${child.label}`]
  })
  return affected.length
    ? `Answer the following question or remove its note and attachments before submitting: ${affected.join("; ")}.`
    : undefined
}
